import { ComparePage } from '@/components/marketing/compare-page'

export function CompareGensparkPage() {
  return (
    <ComparePage
      contentKey="compareGenspark"
      path="/compare/genspark"
      otherLabel="Genspark & Felo"
      relatedKeys={['comparePerplexity', 'whatIsKnowledgeGraph', 'useCasesKnowledgeWorkers']}
    />
  )
}
